import { useState, useCallback } from 'react';
import type { Migration, TransformationDefinition } from '../../types';

export const useModalState = () => {
  const [modalState, setModalState] = useState<{
    isOpen: boolean;
    variant:
      | 'delete'
      | 'view'
      | 'startMigration'
      | 'runMigration'
      | 'runSnapshot'
      | 'transformationViewDetails'
      | 'attention';

    job: Migration | null;
    transformation?: TransformationDefinition | null;
  }>({
    isOpen: false,
    variant: 'delete',
    job: null,
    transformation: null
  });

  const handleViewClick = useCallback((job: Migration) => {
    setModalState({ isOpen: true, variant: 'view', job });
  }, []);

  const handleAttentionClick = useCallback((job: Migration) => {
    setModalState({ isOpen: true, variant: 'attention', job });
  }, []);

  const handleDeleteClick = useCallback((job: Migration) => {
    setModalState({ isOpen: true, variant: 'delete', job });
  }, []);

  const handleTransformationViewDetailsClick = useCallback(
    (transformation: TransformationDefinition) => {
      setModalState({
        isOpen: true,
        variant: 'transformationViewDetails',
        job: null,
        transformation
      });
    },
    []
  );

  const handleModalClose = useCallback(() => {
    setModalState({ isOpen: false, variant: 'delete', job: null });
  }, []);

  const handleRunMigrationClick = useCallback(() => {
    setModalState({ isOpen: true, variant: 'runMigration', job: null });
  }, []);

  const handleCaptureSnapshotClick = useCallback(() => {
    setModalState({ isOpen: true, variant: 'runSnapshot', job: null });
  }, []);

  return {
    modalState,
    handleViewClick,
    handleAttentionClick,
    handleDeleteClick,
    handleModalClose,
    handleRunMigrationClick,
    handleTransformationViewDetailsClick,
    handleCaptureSnapshotClick
  };
};

export default useModalState;
